module.exports = __webpack_public_path__ + "img/mina.1aa11b76.png";